import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import {
  Container,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { colors } from '../theme';

const HomePage = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'relative',
        backgroundImage: 'url(/hero-bg.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: `linear-gradient( ${colors.royalBlue}55 0%, #1565C055 100%)`,
        },
      }}
    >
      <Container maxWidth="md" sx={{ textAlign: 'center', py: 6, position: 'relative', zIndex: 1 }}>
        <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700, color: 'white' }}>
          {t('welcome')}
        </Typography>
        <Typography variant="h6" sx={{ mb: 5, opacity: 0.9, color: 'white' }}>
          {t('welcomeDesc')}
        </Typography>
        <Button
          component={RouterLink}
          to="/search"
          variant="contained"
          size="large"
          startIcon={<SearchIcon />}
          sx={{
            backgroundColor: colors.gold,
            color: 'white',
            fontWeight: 700,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            '&:hover': { backgroundColor: '#e6b800' },
          }}
        >
          {t('search')}
        </Button>
      </Container>
    </Box>
  );
};

export default HomePage;
